import script from "./AlarmsRepositoryUpsert.vue?vue&type=script&lang=ts&setup=true"
export * from "./AlarmsRepositoryUpsert.vue?vue&type=script&lang=ts&setup=true"

import "./AlarmsRepositoryUpsert.vue?vue&type=style&index=0&id=51eaaf21&lang=scss"

const __exports__ = script;

export default __exports__